var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoLog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.455,
    height: 18.455,
    viewBox: "0 0 18.455 18.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_90",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 90",
    transform: "translate(-22 -176.772)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_313",
    "data-name": "\\u30D1\\u30B9 313",
    d: "M176.8,161.392l2.337,1.8.033.019.015.008a.535.535,0,0,0,.648-.143l.016-.015,2.864-3.388a.389.389,0,1,0-.575-.512l-2.677,2.86-2.067-1.439a.506.506,0,0,0-.592.808Z",
    transform: "translate(-148.271 23.504)",
    fill: "#28a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_314",
    "data-name": "\\u30D1\\u30B9 314",
    d: "M61.335,246.125a3.453,3.453,0,0,1,.016-.369H59.884c-.009.121-.011.245-.011.369s0,.248.011.37h1.467A3.46,3.46,0,0,1,61.335,246.125Z",
    transform: "translate(-35.715 -60.125)",
    fill: "#28a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_315",
    "data-name": "\\u30D1\\u30B9 315",
    d: "M151.425,83.6c.139-.088.28-.171.424-.244l.056-.027-.731-1.269a5.66,5.66,0,0,0-.534.307l.731,1.27Z",
    transform: "translate(-123.21 97.673)",
    fill: "#28a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_316",
    "data-name": "\\u30D1\\u30B9 316",
    d: "M82.071,151.169l1.27.731.307-.533-1.27-.731A5.674,5.674,0,0,0,82.071,151.169Z",
    transform: "translate(-57.113 31.567)",
    fill: "#28a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_317",
    "data-name": "\\u30D1\\u30B9 317",
    d: "M386.409,326.262c-.076.144-.156.285-.247.422l-.037.054,1.27.731c.112-.173.215-.348.309-.531l-1.267-.734Z",
    transform: "translate(-350.208 -137.673)",
    fill: "#28a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_318",
    "data-name": "\\u30D1\\u30B9 318",
    d: "M83.368,326.261l-.029-.056-1.267.731a5.255,5.255,0,0,0,.307.534l1.27-.731-.037-.054A4.6,4.6,0,0,1,83.368,326.261Z",
    transform: "translate(-57.113 -137.674)",
    fill: "#28a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_319",
    "data-name": "\\u30D1\\u30B9 319",
    d: "M151.425,386.149l-.054-.037-.731,1.27a5.769,5.769,0,0,0,.534.31l.731-1.27-.056-.027A4.652,4.652,0,0,1,151.425,386.149Z",
    transform: "translate(-123.21 -195.422)",
    fill: "#28a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_320",
    "data-name": "\\u30D1\\u30B9 320",
    d: "M326.214,83.325l.534.31.731-1.27a5.68,5.68,0,0,0-.531-.307Z",
    transform: "translate(-292.456 97.672)",
    fill: "#28a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_321",
    "data-name": "\\u30D1\\u30B9 321",
    d: "M245.771,410.713v1.465c.122.011.245.013.369.013s.248,0,.369-.013V410.7h-.738Z",
    transform: "translate(-214.912 -219.122)",
    fill: "#28a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_322",
    "data-name": "\\u30D1\\u30B9 322",
    d: "M246.509,61.346V59.881c-.121-.011-.245-.013-.369-.013s-.247,0-.369.013v1.48h.738Z",
    transform: "translate(-214.912 119.062)",
    fill: "#28a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_323",
    "data-name": "\\u30D1\\u30B9 323",
    d: "M326.214,386.423l.734,1.268c.182-.1.358-.2.531-.31l-.731-1.27Z",
    transform: "translate(-292.456 -195.421)",
    fill: "#28a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_324",
    "data-name": "\\u30D1\\u30B9 324",
    d: "M387.706,151.169a5.77,5.77,0,0,0-.309-.534l-1.27.731.31.533Z",
    transform: "translate(-350.208 31.567)",
    fill: "#28a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_325",
    "data-name": "\\u30D1\\u30B9 325",
    d: "M412.195,245.757h-1.482v.738h1.482c.009-.122.011-.245.011-.37S412.2,245.878,412.195,245.757Z",
    transform: "translate(-373.909 -60.126)",
    fill: "#28a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_326",
    "data-name": "\\u30D1\\u30B9 326",
    d: "M9.232,0A9.228,9.228,0,1,0,18.46,9.228a9.49,9.49,0,0,0-1.091-4.356,8.766,8.766,0,0,0-2.177-2.727A9.132,9.132,0,0,0,9.232,0Zm0,17.264a8.037,8.037,0,1,1,5.683-2.354A8.008,8.008,0,0,1,9.232,17.264Z",
    transform: "translate(21.995 176.772)",
    fill: "#28a0a0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLog);
export default __webpack_public_path__ + "static/media/ico-log.c45c6792e139cfa95292e4577ed41dcf.svg";
export { ForwardRef as ReactComponent };